import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {NavLink} from "react-router-dom";
import ScrollContainer from 'react-indiana-drag-scroll';
import {twillBase} from "../../config/API";
import {isInternalLink} from "../../helpers/filters";
import './SubNav.scss';

const shouldBeExactMatch = path => {
    const allowSubPageMatches = [
        '/careers/stories'
    ];

    return !allowSubPageMatches.includes(path);
};

const SubNav = ({name}) => {
    const [menuData, setMenuData] = useState([]);

    if (!name || name.length === 0) {
        return <React.Fragment />;
    }

    useEffect(() => {
        fetch(`${twillBase}/api/nav-blocks/${name}`)
            .then((res) => res.json())
            .then((data) => setMenuData(data))
            .catch((err) => console.error("Error fetching menu:", err));
    }, []);

    if (!menuData || !menuData.blocks || !menuData.blocks.length) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            <div id="site-sub-navigation" className="site-header__site-subNav">
                <div className="container">
                    <ScrollContainer
                        className="subNav"
                        component="ul">
                                        {menuData.blocks.map(link => (
                                            link.url !== undefined && (
                                                <li key={`${link.id}_${link.label}`} className="subNav__item" id={`subnav-item-${link.id}`}>

                                                    {(isInternalLink(link.url)) ?
                                                        <NavLink to={link.url} activeClassName="active"
                                                                 exact={shouldBeExactMatch(link.url)}>
                                                            {link.label}
                                                        </NavLink>
                                                        :
                                                        <NavLink to={link.url} activeClassName="active" target="_blank"
                                                                 exact={shouldBeExactMatch(link.url)}>
                                                            {link.label}
                                                        </NavLink>
                                                    }
                                                </li>
                                            )
                                        ))}
                    </ScrollContainer>

                </div>
            </div>
        </React.Fragment>
    );
};

SubNav.propTypes = {
   name: PropTypes.string.isRequired
};

export default SubNav;



// WEBPACK FOOTER //
// ./frontend/components/Header/SubNav.jsx